import { createContext, useContext } from 'react'
import { isFeatureEnabledByDefault } from '@/shared/config/featureToggle'
import { FeatureToggleDefaultEnabled } from '@/shared/constants/featuresFlag'

const UIThemeContext = createContext({ isModernUI: true })

// eslint-disable-next-line react-refresh/only-export-components
export const useUITheme = () => useContext(UIThemeContext)

// [LEGACY] — remove when VITE_MODERN_UI is retired:
//   • delete isModernUI constant and its imports below
//   • replace UIThemeProvider with: <div className="theme-na">{children}</div>
//   • remove useUITheme hook and UIThemeContext entirely
// Computed once at module load — VITE_MODERN_UI_ENABLED is baked in at build time.
// In dev/sut, sessionStorage override is also respected.
const isModernUI = isFeatureEnabledByDefault(FeatureToggleDefaultEnabled.modernUI)

export const UIThemeProvider = ({ children }) => (
  <UIThemeContext.Provider value={{ isModernUI }}>
    <div className={isModernUI ? 'theme-na' : 'theme-legacy'}>
      {children}
    </div>
  </UIThemeContext.Provider>
)
// [/LEGACY]
